import type { ReactNode } from 'react';
import { shellLocale } from './shell-texts';
import { ShellLocaleContext, browserLanguage } from './use-shell-texts';

/**
 * Which language the chrome speaks. Logged in: the layout's `meta.language` (the user's own
 * preference, as the backend resolved it). Before that: the browser's.
 */
export function ShellLocaleProvider({
  language,
  children,
}: {
  /** A backend (`dk`) or browser (`da-DK`) language code; undefined falls back to the browser. */
  language: string | null | undefined;
  children: ReactNode;
}) {
  const locale = shellLocale(language ?? browserLanguage());
  return <ShellLocaleContext value={locale}>{children}</ShellLocaleContext>;
}
